import { Pipe, PipeTransform } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

/**
 * Pipe para traducir items de catálogos del backend
 * Uso: {{ item | catalogTranslate:'catalogType' }}
 * Ejemplo: {{ plan | catalogTranslate:'plans' }}
 * 
 * El item debe tener la estructura: { id: number, name: string }
 */
@Pipe({
  name: 'catalogTranslate',
  standalone: true,
  pure: true
})
export class CatalogTranslatePipe implements PipeTransform {
  private catalogCache: { [key: string]: any } = {};

  constructor(
    private http: HttpClient,
    private translate: TranslateService
  ) {}

  transform(item: any, catalogType: string): Observable<string> {
    // Si no hay item, retornar vacío
    if (!item) {
      return of('');
    }

    // Obtener el ID del item (puede ser 'id' o 'value')
    const itemId = item.id || item.value;
    // Obtener el nombre original (puede ser 'name' o 'description')
    const itemName = item.name || item.description || '';

    // Si no tiene ID, retornar vacío
    if (!itemId) {
      return of('');
    }

    const currentLang = this.translate.currentLang || 'es';
    const cacheKey = `${currentLang}_${catalogType}`;

    // Si ya está en cache, usar el cache
    if (this.catalogCache[cacheKey]) {
      const translation = this.catalogCache[cacheKey][itemId];
      return of(translation || itemName);
    }

    // Si no está en cache, cargar el catálogo
    return this.http.get(`/assets/i18n/catalogs/${currentLang}.json`).pipe(
      map((catalogs: any) => {
        const catalogData = catalogs[catalogType] || {};
        this.catalogCache[cacheKey] = catalogData;
        
        // Buscar traducción por ID
        const translation = catalogData[itemId];
        return translation || itemName;
      }),
      catchError((error) => {
        console.error(`❌ [CatalogTranslatePipe] Error cargando catálogo ${catalogType}:`, error);
        // En caso de error, devolver el nombre original
        return of(itemName);
      })
    );
  }
}
